import { a as O } from "./tw-cn-mXgPecoF.mjs";
const m = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, y = O, b = (e, a) => (n) => {
  var s;
  if ((a == null ? void 0 : a.variants) == null) return y(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: u } = a, V = Object.keys(r).map((t) => {
    const l = n == null ? void 0 : n[t], d = u == null ? void 0 : u[t];
    if (l === null) return null;
    const i = m(l) || m(d);
    return r[t][i];
  }), v = n && Object.entries(n).reduce((t, l) => {
    let [d, i] = l;
    return i === void 0 || (t[d] = i), t;
  }, {}), f = a == null || (s = a.compoundVariants) === null || s === void 0 ? void 0 : s.reduce((t, l) => {
    let { class: d, className: i, ...N } = l;
    return Object.entries(N).every((C) => {
      let [c, o] = C;
      return Array.isArray(o) ? o.includes({
        ...u,
        ...v
      }[c]) : {
        ...u,
        ...v
      }[c] === o;
    }) ? [
      ...t,
      d,
      i
    ] : t;
  }, []);
  return y(e, V, f, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function k(e, a) {
  return b(e, a);
}
export {
  k as c
};
